<script>
  import AppInviteAjax from '@ajax/app_invite';
  import Notification from '@utils/notification';
  import { onMount } from 'svelte';
  import Viewport from '@components/Viewport.svelte';

  import { browser } from '$app/environment';
  import { goto } from '$app/navigation';
  import { saveUtmsToCookie, saveExternalLinkTracking } from '@utils/utm';
  import { getCurrentUserStore } from '@stores/current_user';

  import Track from '@utils/track';
  import MutualSuggestedFollowAjax from '@ajax/mutual_suggested_follow';
  import MobileHeader from '@app-components/mobile/Header.svelte';
  import CreateAccountModal from '@app-components/modal/CreateAccountModal.svelte';
  import Photos from '@app-components/rec_object/parts/Photos.svelte';
  import TermsAndPrivacyFooter from '@app-components/TermsAndPrivacyFooter.svelte';
  import FaqLayout from '../faq/Layout.svelte';

  import Cookie from 'js-cookie';
  import jQuery from 'jquery';
  import queryString from 'query-string';

  import '@vendor/default-landing-page.css';

  export let inviteCode = null;

  let currentUser = getCurrentUserStore('default');

  let verifyCode = async function () {
    let verifyCodeFailed = undefined;

    try {
      let resp = await AppInviteAjax.get(inviteCode, {
        withErrorHandling: false,
      });

      trackMsfOrSf(resp);
    } catch (err) {
      inviteCode = null;
      const errorResponse = err && err.responseJSON;
      if (errorResponse && errorResponse.full_errors && errorResponse.full_errors.length > 0) {
        verifyCodeFailed = errorResponse.full_errors[0];
      } else {
        verifyCodeFailed = 'This is not a valid invitation link but you can still proceed with signup';
      }

      Notification.send({
        text: verifyCodeFailed,
        type: 'error',
      });
    }
  };

  let trackMsfOrSf = async (resp) => {
    let msf = queryString.parse(location.search).msf;
    let sf = queryString.parse(location.search).sf;

    if (!msf && !sf) {
      return;
    }

    let mutualSuggestedFollow = null;

    if (msf) {
      mutualSuggestedFollow = await MutualSuggestedFollowAjax.get(msf);
    }

    if (msf && (!mutualSuggestedFollow || !mutualSuggestedFollow.username)) {
      return;
    }

    let username = mutualSuggestedFollow ? mutualSuggestedFollow.username : sf;
    let user = resp.user;

    Track.suggestedInvitesLinkClick({
      instagram_username: username,
      inviterUserId: user && user.id,
    });
  };

  if (inviteCode) {
    (async () => {
      await verifyCode();
    })();
  }

  const tiktokers = [
    {
      url: 'https://benable.com/jwlevitt',
      view_urls: {
        full_size: '/images/landing_page/tiktok/tiktokers/1@2x.png',
      },
    },
    {
      url: 'https://benable.com/Bougiebarrelracer',
      view_urls: {
        full_size: '/images/landing_page/tiktok/tiktokers/2@2x.png',
      },
    },
    {
      url: 'https://benable.com/megreily',
      view_urls: {
        full_size: '/images/landing_page/tiktok/tiktokers/3@2x.png',
      },
    },
    {
      url: 'https://benable.com/Hammsmom',
      view_urls: {
        full_size: '/images/landing_page/tiktok/tiktokers/4@2x.png',
      },
    },
    {
      url: 'https://benable.com/itsamymajor',
      view_urls: {
        full_size: '/images/landing_page/tiktok/tiktokers/5@2x.png',
      },
    },
    {
      url: 'https://benable.com/Lumi',
      view_urls: {
        full_size: '/images/landing_page/tiktok/tiktokers/6@2x.png',
      },
    },
    {
      url: 'https://benable.com/TravelExploreProtect',
      view_urls: {
        full_size: '/images/landing_page/tiktok/tiktokers/7@2x.png',
      },
    },
    {
      url: 'https://benable.com/mrsspacecadet',
      view_urls: {
        full_size: '/images/landing_page/tiktok/tiktokers/8@2x.png',
      },
    },
    {
      url: 'https://benable.com/tenizi',
      view_urls: {
        full_size: '/images/landing_page/tiktok/tiktokers/9@2x.png',
      },
    },
    {
      url: 'https://benable.com/bowiesbooks',
      view_urls: {
        full_size: '/images/landing_page/tiktok/tiktokers/10@2x.png',
      },
    },
    {
      url: 'https://benable.com/Crystalsvieww',
      view_urls: {
        full_size: '/images/landing_page/tiktok/tiktokers/11@2x.png',
      },
    },
    {
      url: 'https://benable.com/Witteartistry',
      view_urls: {
        full_size: '/images/landing_page/tiktok/tiktokers/12@2x.png',
      },
    },
    {
      url: 'https://benable.com/steph',
      view_urls: {
        full_size: '/images/landing_page/tiktok/tiktokers/13@2x.png',
      },
    },
    {
      url: 'https://benable.com/Intolerant_Furball',
      view_urls: {
        full_size: '/images/landing_page/tiktok/tiktokers/14@2x.png',
      },
    },
  ];

  const instagramLink = 'https://instagram.com/benable_hq';
  let featuredListLink = '/discover?category=content%20creators/social%20media';

  let ready = {
    desktop: {
      src: '/images/landing_page/tiktok/ready.svg',
    },
    mobile: {
      src: '/images/landing_page/tiktok/ready-mobile.svg',
    },
  };

  let headerBgImage = '/images/landing_page/tiktok/bg-header.png';
  let logoSrc = '/images/landing_page/tiktok/logo.svg';

  let headerImages = {
    ipadBottom1: {
      src: '/images/landing_page/tiktok/header-tiktok1.png',
      srcset: '/images/landing_page/tiktok/header-tiktok1.png 1x, /images/landing_page/tiktok/header-tiktok1@2x.png 2x',
    },
  };

  let words = ['products', 'restaurants', 'brands', 'activities', 'anything'];

  let examples = {
    1: {
      url: 'https://benable.com/jeremiahphil/neworleans',
      src: '/images/landing_page/tiktok/lists/1.png',
      srcset: '/images/landing_page/tiktok/lists/1.png 1x, /images/landing_page/tiktok/lists/1@2x.png 2x',
    },
    2: {
      url: 'https://benable.com/elizelliott/beautygotos',
      src: '/images/landing_page/tiktok/lists/2.png',
      srcset: '/images/landing_page/tiktok/lists/2.png 1x, /images/landing_page/tiktok/lists/2@2x.png 2x',
    },
    3: {
      url: 'https://benable.com/penelope6150/baby-travel-must-haves',
      src: '/images/landing_page/tiktok/lists/3.png',
      srcset: '/images/landing_page/tiktok/lists/3.png 1x, /images/landing_page/tiktok/lists/3@2x.png 2x',
    },
    4: {
      url: 'https://benable.com/peter0827/f3c219d6af4cc29fba27',
      src: '/images/landing_page/tiktok/lists/4.png',
      srcset: '/images/landing_page/tiktok/lists/4.png 1x, /images/landing_page/tiktok/lists/4@2x.png 2x',
    },
    5: {
      url: 'https://benable.com/esther7710/f3d43d8341b7cec90cd4',
      src: '/images/landing_page/tiktok/lists/5.png',
      srcset: '/images/landing_page/tiktok/lists/5.png 1x, /images/landing_page/tiktok/lists/5@2x.png 2x',
    },
    6: {
      url: 'https://benable.com/piperr/workoutvideos',
      src: '/images/landing_page/tiktok/lists/6.png',
      srcset: '/images/landing_page/tiktok/lists/6.png 1x, /images/landing_page/tiktok/lists/6@2x.png 2x',
    },
    7: {
      url: 'https://benable.com/alexaaa/912dc97fe7a784261a8d',
      src: '/images/landing_page/tiktok/lists/7.png',
      srcset: '/images/landing_page/tiktok/lists/7.png 1x, /images/landing_page/tiktok/lists/7@2x.png 2x',
    },
    8: {
      url: 'https://benable.com/lillian78329/holiday-gift-guide',
      src: '/images/landing_page/tiktok/lists/8.png',
      srcset: '/images/landing_page/tiktok/lists/8.png 1x, /images/landing_page/tiktok/lists/8@2x.png 2x',
    },
    9: {
      url: 'https://benable.com/leonard0033/75261b79ac22b4fae12d',
      src: '/images/landing_page/tiktok/lists/9.png',
      srcset: '/images/landing_page/tiktok/lists/9.png 1x, /images/landing_page/tiktok/lists/9@2x.png 2x',
    },
  };

  let currentWordIndex = 0;
  let currentLetterIndex = 0;
  let shareListWord = '';

  let showCreateAccountModal = false;
  let signInView = false;

  let examplesArray = [];
  let shownExamplesArray = [];
  let shownPer = 3;

  $: shownExamplesIndex = 0;

  for (const key in examples) {
    examplesArray.push({
      id: key,
      url: examples[key].url,
      srcset: examples[key].srcset,
      view_urls: {
        full_size: examples[key].src,
      },
    });
  }

  $: if (examplesArray.length > 0) {
    shownExamplesArray = [];
    for (let i = shownExamplesIndex; i < shownExamplesIndex + shownPer; i++) {
      shownExamplesArray.push({
        id: examplesArray[i].id,
        url: examplesArray[i].url,
        srcset: examplesArray[i].srcset,
        view_urls: {
          full_size: examplesArray[i].src,
        },
      });
    }
  }

  let moveShownLeft = function () {
    if (shownExamplesIndex == 0) {
      shownExamplesIndex = examplesArray.length - shownPer;
    } else {
      shownExamplesIndex -= shownPer;
    }
  };

  let moveShownRight = function () {
    if (shownExamplesIndex >= examplesArray.length - shownPer) {
      shownExamplesIndex = 0;
    } else {
      shownExamplesIndex += shownPer;
    }
  };

  let setClassIfDown = function () {
    if (jQuery(window).scrollTop() >= 20) {
      jQuery('.landing-header').addClass('landing-header-scrolled');
    } else {
      jQuery('.landing-header').removeClass('landing-header-scrolled');
    }
  };

  let displayCreateAccountModal = function () {
    signInView = false;
    showCreateAccountModal = true;
  };

  let displayCreateAccountLoginModal = function () {
    signInView = true;
    showCreateAccountModal = true;
  };

  let setupTypingAnimation = function () {
    const waitInterval = 1000;
    const typingInterval = 70;
    let totalWaitTime = 0;
    let reversed = false;

    setInterval(() => {
      let currentWord = words[currentWordIndex];
      let nextLetter = currentWord[currentLetterIndex];

      if (nextLetter) {
        if (reversed) {
          shareListWord = shareListWord.slice(0, currentLetterIndex - 1);
          currentLetterIndex -= 1;
        } else {
          shareListWord += nextLetter;
          currentLetterIndex += 1;
        }
      } else {
        totalWaitTime += typingInterval;

        if (totalWaitTime >= waitInterval) {
          if (reversed === false) {
            reversed = true;
            currentLetterIndex -= 1;
          } else if (reversed === true && currentLetterIndex < 0) {
            currentWordIndex += 1;
            totalWaitTime = 0;
            currentLetterIndex = 0;
            shareListWord = '';
            reversed = false;

            if (currentWordIndex >= words.length) {
              currentWordIndex = 0;
            }
          }
        }
      }
    }, typingInterval);
  };

  let setScrollToTiktoker = function (node) {
    jQuery(node).scrollLeft(1440);
  };

  let trackFacebookPixel = function () {
    if (typeof window !== 'undefined' && window.fbq !== undefined && (!currentUser || !currentUser.id)) {
      window.fbq('track', 'Referral Page View Logged Out');
    }
  };

  if (browser) {
    Cookie.set('landing-page', 'tiktok');
    saveUtmsToCookie();
    saveExternalLinkTracking(inviteCode);
  }

  onMount(() => {
    setClassIfDown();
    setupTypingAnimation();
    trackFacebookPixel();

    jQuery(window).scroll(setClassIfDown);

    if (location.href.includes('#faq-section')) {
      setTimeout(() => {
        jQuery(window).scrollTop(jQuery('#faq-section').position().top);
      }, 250);
    }
  });
</script>

<style style="text/scss" lang="scss">
  .content-oxrTxx :global(.mode-dropdown) {
    height: 58px;
  }

  .content-oxrTxx :global(.fa-search) {
    top: 22px !important;
  }

  .content-oxrTxx :global(.arrow-customization) {
    left: 5px;
    margin-top: -4px;
  }

  .content-oxrTxx :global(#select-recommendation-input) {
    margin: 0px;
    background-color: #fff;
    padding-right: 110px;
    height: 58px;
    border-radius: 12px;
    border: 2px solid transparent;

    &:hover {
      border: 2px solid #ede9fd;
    }

    &:focus {
      outline: none;
      border: 2px solid #a893f9;
    }

    &::placeholder {
      opacity: 0.4;
    }
  }

  .examples-desktop-container {
    img:not(.controls) {
      &:hover {
        box-shadow: 0px 22px 100px rgba(0, 0, 0, 0.2) !important;
      }
    }

    svg {
      cursor: pointer;

      &:hover {
        rect {
          fill: #b3a4e8;
        }

        path {
          stroke: white;
        }
      }
    }
  }

  .white-button-link {
    background: white;
    box-shadow: 0px 0px 40px rgba(168, 147, 249, 0.24);
    border-radius: 15px;
    padding-left: 34px;
    padding-right: 34px;
    height: 46px;
    align-items: center;
    display: flex !important;
    color: #a893f9;
    font-weight: 500;

    &:hover {
      background: black;
      color: white;
    }
  }

  * :global(.example-images-mobile .owl-stage-outer) {
    overflow: initial !important;
  }

  * :global(.example-images-mobile .owl-dots .active span) {
    background: #8e71ff !important;
    opacity: 1 !important;
  }

  * :global(.example-images-mobile .owl-dots span) {
    background: #a893f9 !important;
    opacity: 0.4 !important;
  }

  * :global(.example-images-mobile .owl-dots) {
    bottom: -40px;
  }

  * :global(.landing-header-scrolled) {
    background: black !important;
  }

  * :global(.landing-header-link) {
    color: white !important;

    &:hover {
      color: #ddd !important;
    }
  }

  * :global(.title-hddQkX),
  * :global(.title-LxFJVx),
  * :global(.title-sVJY7g),
  * :global(.title-eIPOwk),
  * :global(.title-h0u3WP),
  * :global(.title-NuO8zd) {
    color: white;
  }

  * :global(.title-0ecNxq),
  * :global(.title-3Pr9RJ) {
    color: #fe2b54;
    background: #1d1919;
  }

  * :global(.benable-automat-recommendations-R5c8U8),
  * :global(.benable-automat-recommendations-VpwlJ3) {
    color: white;
    opacity: 0.6;
  }

  * :global(.ipad-baby-rec-1-cmgjxk) {
    top: -220px !important;
    left: -120px !important;
  }

  * :global(.bg-header-fhdGzq) {
    margin-top: -100px;
  }

  * :global(.view-demo-btn) {
    display: none !important;
  }

  * :global(.signup-link),
  * :global(.landing-header-link.signup-link) {
    background: #fe2b54 !important;
    box-shadow: 0px 13px 40px rgba(168, 147, 249, 0.394586);
    border-radius: 15px;

    &:hover {
      background: #e4264b !important;
      color: white !important;
    }
  }

  * :global(.explore-more-btn),
  * :global(.view-faq-btn),
  * :global(.give-it-a-try-btn) {
    filter: drop-shadow(3px -3px 0 #24f6f0) brightness(110%);
    box-shadow: -3px 3px 0 0 #fe2d52;
    background: black !important;
    color: white;

    &:hover {
      background: #111 !important;
      color: #eee !important;
    }
  }

  * :global(#select-recommendation-input) {
    filter: drop-shadow(3px -3px 0 #24f6f0) brightness(110%);
    box-shadow: -3px 3px 0 0 #fe2d52;
    border: 0px !important;

    &::placeholder {
      color: black;
    }

    &:focus,
    &:hover {
      border: 0px !important;
    }
  }

  * :global(.try-it-btn) {
    background: black;
    color: white;

    &:hover {
      background: #333 !important;
    }
  }

  * :global(.vector-5-sbFa6x) {
    width: 100%;
  }

  * :global(.title-sbFa6x),
  * :global(.benable-is-the-s-you-recommend-sbFa6x) {
    display: none;
  }

  * :global(.rectangle-copy-55-sbFa6x) {
    background: unset;
  }

  * :global(.overlay-6yINq5) {
    height: unset;
  }

  * :global(.m-header-container) {
    background: black !important;
    width: 100%;
    position: absolute !important;
    margin-top: 0px !important;
  }

  * :global(.m-header-container .mobile-signup-link) {
    color: white;
  }

  * :global(.m-header-container .m-gear path) {
    fill: white;
  }

  * :global(.faq-main-header),
  * :global(.faq-title) {
    display: none;
  }

  * :global(.question-answer) {
    border-bottom: 1px solid #ebe4ff;
    padding-bottom: 22px;
  }

  * :global(.question-answer h2) {
    border-bottom: 0px;
    color: black;
  }

  * :global(.question-answer .answer) {
    padding-top: 10px;
  }

  * :global(.owl-next),
  * :global(.owl-prev) {
    height: 32px !important;
    width: 32px !important;
    border-radius: 999px !important;
    margin-top: -28px !important;
    background: white !important;
    color: #a893f9 !important;
    opacity: 1 !important;

    &:hover {
      background: #a893f9 !important;
      color: white !important;
    }
  }

  * :global(.ticktokers-container .owl-dot) {
    display: none !important;
  }

  * :global(.owl-stage-outer) {
    padding: 15px !important;
    margin: -15px !important;
  }

  .question-answer {
    position: relative;

    .arrow {
      position: absolute;
      top: 3px;
      right: 0px;
      transition: all 0.1s;
      padding: 15px;
      margin: -15px;
      cursor: pointer;
    }
  }

  * :global(.question-answer.opened .arrow) {
    transform: rotate(180deg);
  }

  * :global(.faq-section-layout .m-header-container) {
    display: none !important;
  }

  .signup-svg {
    cursor: pointer;

    g rect:hover {
      fill: #e4264b;
    }
  }

  .grow {
    transition: all 0.1s ease-in-out;

    &:hover {
      transform: scale(1.05);
    }
  }

  .purple-dot {
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background: #7054dc;
    opacity: 0.4;
    margin-left: 6px;
    margin-right: 6px;
    cursor: pointer;

    &.selected {
      opacity: 1 !important;
    }
  }
</style>

<Viewport let:desktop let:tablet let:mobile TABLET_MIN={1000}>
  {#if showCreateAccountModal}
    <div class="svelte-modal">
      <CreateAccountModal
        eventDetails={signInView ? null : { trigger_event: 'signup_button' }}
        mobile={mobile}
        signInView={signInView}
        successCallback={() => {
          goto(`/discover`);
        }}
        showPassword={true}
        header={signInView ? 'Sign in' : 'Create your free account'}
        namePlaceholder="Full Name"
        inviteCode={inviteCode}
        bind:showModal={showCreateAccountModal}
        beforeDataSend={(data) => {
          data['landing_page'] = 'tiktok';
          data['sign_up_source'] = {
            source: 'app-invite',
          };
          return data;
        }}
        inviteFlow={true} />
    </div>
  {/if}

  {#if desktop || tablet}
    <div style="position: absolute; top: 1000px; left: 0px; z-index: 1;">
      <img src="/images/landing_page/tiktok/left-side.png" />
    </div>

    <div style="position: absolute; top: 1150px; right: 0px; z-index: 1;">
      <img src="/images/landing_page/tiktok/right-side.png" />
    </div>

    <div class="container-center-horizontal">
      <div class="x9-05-01-marketing-lp screen" style="height: 6675px;">
        <div class="overlap-group1-C61RwL" style="height: 3400px;">
          <div
            class="ticktokers-container"
            style="position: absolute; top: 1360px; left: 0px; right: 0px; text-align: center; overflow: hidden; height: 290px; z-index: 2;">
            <Photos
              loop={true}
              photos={tiktokers}
              useFancyBox={false}
              maxBigDotsShown={0}
              afterOwlCarouselSetup={(carousel) => {
                setTimeout(() => {
                  carousel.trigger('to.owl.carousel', 4);
                }, 200);
              }}>
              <div
                slot="img"
                let:photo
                class="tiktokers-img grow"
                style="margin-left: 10px; margin-right: 10px; width: 196px; position: relative;"
                on:click|preventDefault|stopPropagation={() => window.open(photo.url)}>
                <a href={photo.url} target="_blank"><img style="width: 196px;" src={photo.view_urls.full_size} /></a>
              </div>
            </Photos>
          </div>

          <div class="magic-RH0WJ5">
            <div class="magic-bN6RVQ">
              <div class="title-nCcR69 helveticaneue-bold-black-42px" style="z-index: 1; margin-top: 0px;">
                A platform for <span style="color: #AE94F9">creators</span> to compile and share their recommendations
              </div>

              <div style="margin-top: 420px">
                <img
                  src="/images/landing_page/tiktok/anything.png"
                  srcset="/images/landing_page/tiktok/anything.png 1x, /images/landing_page/tiktok/anything@2x.png 2x" />
              </div>

              <div style="margin-top: 120px; margin-left: auto; margin-right: auto; max-width: 770px; z-index: 1;">
                <div style="font-weight: 700; font-size: 42px; line-height: 50px; text-align: center;">
                  Earn passive income
                </div>
                <div
                  style="font-weight: 400; font-size: 20px; line-height: 32px; color: #5E518E; margin-top: 24px; text-align: center;">
                  Benable has partnered with <b>35,000+</b> sites that pay you when people purchase things from your lists.
                  When you join Benable you INSTANTLY get approved for all programs! Keep the full commission, Benable doesn't
                  take a cent.
                </div>
              </div>
              <div style="margin-top: 60px; padding: 10px; position: relative;">
                <img
                  src="/images/landing_page/tiktok/affiliates-background.png"
                  style="position: absolute; top: -200px; right: 0px; left: 0px; width: 100%;" />
                <img src="/images/landing_page/tiktok/affiliates@2x.png" style="position: inherit; height: 196px;" />
              </div>
            </div>
          </div>
          <div class="header-RH0WJ5">
            <div class="bg-gtrbIB">
              <img alt="landing page" class="bg-header-fhdGzq" src={headerBgImage} />
            </div>

            <div style="position: relative;">
              <div class="group-653-fhdGzq">
                {#if headerImages.ipadTop1}
                  <div class="ipad-yu9gF4">
                    <img
                      alt="landing page"
                      class="ipad-camping-1-Ild3KG"
                      src={headerImages.ipadTop1.src}
                      srcset={headerImages.ipadTop1.srcset} />
                  </div>
                {/if}
                <div class="overlap-group2-yu9gF4">
                  {#if headerImages.ipadTop2}
                    <div class="ipad-yu9gF4" style="left: 690px; top: -388px;">
                      <img
                        alt="landing page"
                        class="ipad-camping-1-Ild3KG"
                        style="height: unset;"
                        src={headerImages.ipadTop2.src}
                        srcset={headerImages.ipadTop2.srcset} />
                    </div>
                  {/if}

                  {#if headerImages.ipadBottom2}
                    <div class="ipad-RMHuGM">
                      <img
                        alt="landing page"
                        loading="lazy"
                        class="shadow-sAiVBm"
                        src="/images/default-landing-page/shadow@2x.svg" />
                      <img
                        alt="landing page"
                        loading="lazy"
                        class="ipad-maui-1-sAiVBm"
                        src={headerImages.ipadBottom2.src}
                        srcset={headerImages.ipadBottom2.srcset} />
                    </div>
                  {/if}
                  {#if headerImages.iphone}
                    <div class="iphone-RMHuGM">
                      <img
                        alt="landing page"
                        loading="lazy"
                        class="shadow-Jq7GZi"
                        src="/images/default-landing-page/shadow-1@2x.svg" />
                      <img
                        alt="landing page"
                        loading="lazy"
                        class="phone-4-Jq7GZi"
                        src={headerImages.iphone.src}
                        srcset={headerImages.iphone.srcset} />
                    </div>
                  {/if}
                  {#if headerImages.ipad2}
                    <div alt="landing page" class="ipad-FjwPun" style="left: 740px;">
                      <img
                        alt="landing page"
                        loading="lazy"
                        class="ipad-beauty-1-x7vkjd"
                        src={headerImages.ipad2.src}
                        srcset={headerImages.ipad2.srcset} />
                    </div>
                  {/if}
                  {#if headerImages.iphoneBottom}
                    <div class="iphone-xF8VaB">
                      <img
                        alt="landing page"
                        loading="lazy"
                        class="shadow-EGzQNO"
                        src="/images/default-landing-page/shadow-2@2x.svg" />
                      <img
                        alt="landing page"
                        loading="lazy"
                        class="phone-4-EGzQNO"
                        src={headerImages.iphoneBottom.src}
                        srcset={headerImages.iphoneBottom.srcset} />
                    </div>
                  {/if}
                  {#if headerImages.ipadBottom1}
                    <div class="ipad-xF8VaB">
                      <img
                        alt="landing page"
                        loading="lazy"
                        class="shadow-cmgjxk"
                        src="/images/default-landing-page/shadow-3@2x.svg" />
                      <img
                        alt="landing page"
                        loading="lazy"
                        class="ipad-baby-rec-1-cmgjxk"
                        src={headerImages.ipadBottom1.src}
                        srcset={headerImages.ipadBottom1.srcset} />
                    </div>
                  {/if}
                  {#if headerImages.ipad1}
                    <div class="ipad-FjwPun">
                      <img
                        alt="landing page"
                        loading="lazy"
                        class="shadow-x7vkjd"
                        src="/images/default-landing-page/shadow-4@2x.svg" />
                      <img
                        alt="landing page"
                        loading="lazy"
                        class="ipad-beauty-1-x7vkjd"
                        src={headerImages.ipad1.src}
                        srcset={headerImages.ipad1.srcset} />
                    </div>
                  {/if}
                </div>
              </div>
              <div class="header-content-gtrbIB">
                <div class="changeable-parts-R5c8U8">
                  <div class="title-hddQkX helveticaneue-bold-black-72px">Shareable lists</div>
                  <div class="overlap-group2-hddQkX">
                    <div class="group-668-LxFJVx">
                      <div class="group-667-lnNNOm">
                        <div class="group-666-59Hva9">
                          <div class="group-665-g17xPS">
                            <div class="title-sVJY7g helveticaneue-bold-black-72px">you recommend</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="title-LxFJVx helveticaneue-bold-black-72px">of</div>
                    <div class="title-0ecNxq">
                      <div>{shareListWord}</div>
                      <img
                        alt="landing page"
                        loading="lazy"
                        class="line-3-LxFJVx"
                        src="/images/default-landing-page/line-3@2x.svg" />
                    </div>
                  </div>
                </div>
                <div class="benable-automat-recommendations-R5c8U8 helveticaneue-regular-normal-butterfly-bush-20px">
                  Earn passive income, save time, and delight followers! Recommend everything you love in one place.
                </div>

                <div
                  class="overlap-group3-R5c8U8"
                  style="position: relative; margin-top: -15px;"
                  on:click={displayCreateAccountModal}>
                  <svg
                    style="position: absolute; left: -40px;"
                    width="386"
                    height="128"
                    viewBox="0 0 386 128"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="signup-svg">
                    <rect x="36" y="31.999" width="306" height="47" rx="16" fill="#2CEFEF" />
                    <rect opacity="0.24" x="44" y="22.999" width="306" height="48" rx="16" fill="white" />
                    <g filter="url(#filter0_d_1941_113883)">
                      <rect x="40" y="26.999" width="306" height="48" rx="15" fill="#FE2B54" />
                    </g>
                    <defs>
                      <filter
                        id="filter0_d_1941_113883"
                        x="0"
                        y="-0.000976562"
                        width="386"
                        height="128"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha" />
                        <feOffset dy="13" />
                        <feGaussianBlur stdDeviation="20" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.658824 0 0 0 0 0.576471 0 0 0 0 0.976471 0 0 0 0.394586 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1941_113883" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1941_113883" result="shape" />
                      </filter>
                    </defs>
                  </svg>
                  <div
                    style="position: absolute; top: 41px; left: 128px; text-align: center; z-index: 1; pointer-events: none; color: white; font-weight: 500;">
                    Sign up
                  </div>
                </div>
                <slot name="below-input" mobile={false} />
              </div>
            </div>
          </div>
          <div class="landing-header">
            <div style="flex: 1">
              <a href="/" class="navbar-brand p-0 my-0 ml-0 c-mr-3 d-flex align-items-center">
                <img
                  alt="landing page"
                  loading="lazy"
                  src={logoSrc}
                  class="navbar-brand__logo d-block adjustable-element" />
              </a>
            </div>
            <div class="landing-header-link-container">
              <a href={featuredListLink} class="landing-header-link" target="_blank"> Browse lists </a>
              <a href="#faq-section" class="landing-header-link"> FAQ </a>
              <a
                target="_blank"
                href="#"
                on:click|preventDefault={displayCreateAccountLoginModal}
                class="landing-header-link">
                Login
              </a>
              <a
                target="_blank"
                href
                class="landing-header-link white-button-link signup-link"
                on:click|preventDefault={displayCreateAccountModal}>
                Sign up
              </a>
            </div>
          </div>
        </div>

        <div class="how-does-benable-work-C61RwL" style="margin-bottom: -380px; margin-top: 10px;">
          <div class="header-0MKM4B" style="margin-bottom: -80px;">
            <div class="how-it-works-3Uj7HY" style="z-index: 1;">
              <div class="title-WKgWjq helveticaneue-bold-black-42px">How does it work?</div>
              <div class="create-a-sharea-mend-in-3-steps-WKgWjq helveticaneue-regular-normal-butterfly-bush-20px">
                Create a shareable list of things you recommend in 3 steps!
              </div>
            </div>
          </div>

          <div class="overlap-group4-0MKM4B" style="margin-top: 0px;">
            <div class="background-2Ffn8M">
              <img
                alt="landing page"
                loading="lazy"
                class="ellipse-53-0VveWg"
                src="/images/default-landing-page/ellipse-53@2x.svg" />
              <img
                alt="landing page"
                loading="lazy"
                class="ellipse-55-0VveWg"
                src="/images/default-landing-page/ellipse-53@2x.svg" />
              <img
                alt="landing page"
                loading="lazy"
                class="ellipse-54-0VveWg"
                src="/images/default-landing-page/ellipse-53@2x.svg" />
            </div>
            <img
              alt="landing page"
              loading="lazy"
              class="vector-5-2Ffn8M"
              src="/images/landing_page/tiktok/vector-5@1x.png"
              style="height: unset;" />
            <div class="x01-2Ffn8M" style="top: 0px;">
              <img
                alt="landing page"
                loading="lazy"
                class="illu-create-new-list-pyINk4"
                src="/images/landing_page/tiktok/how-it-works-1.png"
                srcset="/images/landing_page/tiktok/how-it-works-1.png 1x, /images/landing_page/tiktok/how-it-works-1@2x.png 2x"
                style="width: unset; height: unset; top: 120px; left: 30px;" />
              <div class="text-01-pyINk4">
                <div class="title-tEy9a8 helveticaneue-bold-whisper-104px">01</div>
                <div class="title-8AuERU helveticaneue-bold-black-24px">Create a new list</div>
                <div class="title-1xP5hd helveticaneue-regular-normal-butterfly-bush-20px">
                  Add things you recommend by keyword or link
                </div>
              </div>
            </div>
            <div class="x02-2Ffn8M" style="margin-top: -180px;">
              <div class="text-02-sPt9dm">
                <div class="title-RaDTxa helveticaneue-bold-whisper-104px">02</div>
                <div class="title-LfIL6q helveticaneue-bold-black-24px">Share your list</div>
                <div class="title-1xP5hd helveticaneue-regular-normal-butterfly-bush-20px">
                  Add your Benable link to your Bio or Linktree
                </div>
              </div>
              <img
                alt="landing page"
                loading="lazy"
                class="illu-add-sPt9dm"
                style="width: unset; height: unset; top: 120px;"
                src="/images/landing_page/tiktok/how-it-works-2.png"
                srcset="/images/landing_page/tiktok/how-it-works-2.png 1x, /images/landing_page/tiktok/how-it-works-2@2x.png 2x" />
            </div>
            <div class="x03-2Ffn8M" style="margin-top: -270px; margin-left: 110px;">
              <img
                alt="landing page"
                loading="lazy"
                class="illu-share-lhMVN3"
                src="/images/landing_page/tiktok/how-it-works-3.png"
                srcset="/images/landing_page/tiktok/how-it-works-3.png 1x, /images/landing_page/tiktok/how-it-works-3@2x.png 2x"
                style="width: unset; height: unset;" />
              <div class="text-03-lhMVN3" style="margin-top: -20px;">
                <div class="title-dMWdjV helveticaneue-bold-whisper-104px">03</div>
                <div class="title-XUvGJv helveticaneue-bold-black-24px">
                  Earn passive income<br /> & delight followers
                </div>
                <div class="title-Ugix1n helveticaneue-regular-normal-butterfly-bush-20px" style="top: 107px;">
                  Check your dashboard anytime and keep adding things you love!
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="font-weight: 700; font-size: 42px; line-height: 50px; text-align: center; z-index: 1; width: 100%;">
          Discover popular lists on Benable
        </div>

        <div
          style="font-weight: 400; font-size: 20px; line-height: 32px; text-align: center; color: #5E518E; margin-top: 24px; margin-bottom: 20px; width: 100%;">
          The all-in-one tool to share your favorite: products, activities, services, and more!
        </div>

        <div
          class="examples-desktop-container"
          style="margin-left: auto; margin-right: auto; display: flex; z-index: 1; height: 580px; align-items: center; position: relative;">
          <div
            style="margin-right: 26px; visibility: {shownExamplesIndex == 0 ? 'hidden' : ''}"
            on:click={moveShownLeft}>
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="64" height="64" rx="32" fill="#F5F3FC" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M35.7682 38.5802C36.1218 38.0852 36.0645 37.3495 35.6402 36.9371L30.562 32L35.6402 27.0629C36.0645 26.6505 36.1218 25.9148 35.7682 25.4198C35.4147 24.9248 34.7841 24.8579 34.3598 25.2704L28.3598 31.1037C28.1318 31.3254 28 31.6538 28 32C28 32.3462 28.1318 32.6746 28.3598 32.8963L34.3598 38.7296C34.7841 39.1421 35.4147 39.0752 35.7682 38.5802Z"
                fill="#A893F9"
                stroke="#AE94F9"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>

          {#key shownExamplesIndex}
            {#each shownExamplesArray as example}
              <div style="margin-left: 10px; margin-right: 10px;">
                <a href={example.url} target="_blank">
                  <img
                    alt="landing page"
                    loading="lazy"
                    src={example.src}
                    srcset={example.srcset}
                    style="border-radius: 10px; cursor: pointer; box-shadow: 0px 22px 100px rgba(0, 0, 0, 0.12);" />
                </a>
              </div>
            {/each}

            <div style="position: absolute; bottom: 0px; left: 50%; transform: translate(-50%, -50%); display: flex;">
              <div
                class="purple-dot"
                class:selected={shownExamplesIndex == 0}
                on:click={() => (shownExamplesIndex = 0)} />
              <div
                class="purple-dot"
                class:selected={shownExamplesIndex == 3}
                on:click={() => (shownExamplesIndex = 3)} />
              <div
                class="purple-dot"
                class:selected={shownExamplesIndex == 6}
                on:click={() => (shownExamplesIndex = 6)} />
            </div>
          {/key}

          <div
            style="margin-left: 26px; visibility: {shownExamplesIndex >= examplesArray.length - shownPer
              ? 'hidden'
              : ''}"
            on:click={moveShownRight}>
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="64" height="64" rx="32" fill="#F5F3FC" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M28.2318 25.4198C27.8782 25.9148 27.9355 26.6505 28.3598 27.0629L33.438 32L28.3598 36.9371C27.9355 37.3495 27.8782 38.0852 28.2318 38.5802C28.5853 39.0752 29.2159 39.1421 29.6402 38.7296L35.6402 32.8963C35.8682 32.6746 36 32.3462 36 32C36 31.6538 35.8682 31.3254 35.6402 31.1037L29.6402 25.2704C29.2159 24.8579 28.5853 24.9248 28.2318 25.4198Z"
                fill="#A893F9"
                stroke="#AE94F9"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
        </div>

        <div
          style="margin-top: 120px; margin-left: auto; margin-right: auto; max-width: 1180px; max-height: 280px; position: relative;">
          <img alt="landing page" loading="lazy" style="width: 100%; height: 100%;" src={ready.desktop.src} />

          <span on:click={displayCreateAccountModal}>
            <svg
              width="386"
              height="128"
              viewBox="0 0 386 128"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="bottom: -15px; position: absolute; cursor: pointer; left: 50%; transform: translate(-50%, 0%);"
              class="signup-svg">
              <rect x="36" y="32" width="306" height="47" rx="16" fill="#2CEFEF" />
              <rect opacity="0.24" x="44" y="23" width="306" height="48" rx="16" fill="white" />
              <g filter="url(#filter0_d_1975_117543)">
                <rect x="40" y="27" width="306" height="48" rx="15" fill="#FE2B54" />
                <path
                  d="M169.212 52.668C169.212 53.0507 169.277 53.3773 169.408 53.648C169.539 53.9187 169.721 54.1427 169.954 54.32C170.187 54.488 170.453 54.614 170.752 54.698C171.06 54.7727 171.391 54.81 171.746 54.81C172.129 54.81 172.455 54.768 172.726 54.684C172.997 54.5907 173.216 54.474 173.384 54.334C173.552 54.194 173.673 54.0353 173.748 53.858C173.823 53.6713 173.86 53.4847 173.86 53.298C173.86 52.9153 173.771 52.6353 173.594 52.458C173.426 52.2713 173.239 52.1407 173.034 52.066C172.679 51.9353 172.264 51.814 171.788 51.702C171.321 51.5807 170.743 51.4267 170.052 51.24C169.623 51.128 169.263 50.9833 168.974 50.806C168.694 50.6193 168.47 50.414 168.302 50.19C168.134 49.966 168.013 49.728 167.938 49.476C167.873 49.224 167.84 48.9673 167.84 48.706C167.84 48.202 167.943 47.768 168.148 47.404C168.363 47.0307 168.643 46.7227 168.988 46.48C169.333 46.2373 169.725 46.06 170.164 45.948C170.603 45.8267 171.046 45.766 171.494 45.766C172.017 45.766 172.507 45.836 172.964 45.976C173.431 46.1067 173.837 46.3073 174.182 46.578C174.537 46.8487 174.817 47.1847 175.022 47.586C175.227 47.978 175.33 48.4353 175.33 48.958H173.58C173.533 48.314 173.314 47.8613 172.922 47.6C172.53 47.3293 172.031 47.194 171.424 47.194C171.219 47.194 171.009 47.2173 170.794 47.264C170.579 47.3013 170.383 47.3713 170.206 47.474C170.029 47.5673 169.879 47.698 169.758 47.866C169.646 48.034 169.59 48.244 169.59 48.496C169.59 48.8507 169.697 49.1307 169.912 49.336C170.136 49.532 170.425 49.6813 170.78 49.784C170.817 49.7933 170.962 49.8353 171.214 49.91C171.475 49.9753 171.765 50.05 172.082 50.134C172.399 50.218 172.707 50.302 173.006 50.386C173.314 50.4607 173.533 50.5167 173.664 50.554C173.991 50.6567 174.275 50.7967 174.518 50.974C174.761 51.1513 174.961 51.3567 175.12 51.59C175.288 51.814 175.409 52.0567 175.484 52.318C175.568 52.5793 175.61 52.8407 175.61 53.102C175.61 53.662 175.493 54.1427 175.26 54.544C175.036 54.936 174.737 55.258 174.364 55.51C173.991 55.762 173.566 55.944 173.09 56.056C172.614 56.1773 172.129 56.238 171.634 56.238C171.065 56.238 170.528 56.168 170.024 56.028C169.52 55.888 169.081 55.6733 168.708 55.384C168.335 55.0947 168.036 54.726 167.812 54.278C167.588 53.8207 167.471 53.284 167.462 52.668H169.212ZM176.96 46.004H178.556V47.516H176.96V46.004ZM176.96 48.762H178.556V56H176.96V48.762ZM186.987 55.622C186.987 56.714 186.679 57.526 186.063 58.058C185.456 58.5993 184.579 58.87 183.431 58.87C183.067 58.87 182.698 58.8327 182.325 58.758C181.961 58.6833 181.625 58.5573 181.317 58.38C181.018 58.2027 180.766 57.9693 180.561 57.68C180.356 57.3907 180.234 57.036 180.197 56.616H181.793C181.84 56.84 181.919 57.022 182.031 57.162C182.143 57.302 182.274 57.4093 182.423 57.484C182.582 57.568 182.754 57.6193 182.941 57.638C183.128 57.666 183.324 57.68 183.529 57.68C184.173 57.68 184.644 57.5213 184.943 57.204C185.242 56.8867 185.391 56.4293 185.391 55.832V54.726H185.363C185.139 55.1273 184.831 55.44 184.439 55.664C184.056 55.888 183.641 56 183.193 56C182.614 56 182.12 55.902 181.709 55.706C181.308 55.5007 180.972 55.2253 180.701 54.88C180.44 54.5253 180.248 54.1193 180.127 53.662C180.006 53.2047 179.945 52.7147 179.945 52.192C179.945 51.7067 180.02 51.2447 180.169 50.806C180.318 50.3673 180.533 49.9847 180.813 49.658C181.093 49.322 181.434 49.056 181.835 48.86C182.246 48.664 182.708 48.566 183.221 48.566C183.678 48.566 184.098 48.664 184.481 48.86C184.864 49.0467 185.158 49.3453 185.363 49.756H185.391V48.762H186.987V55.622ZM183.445 54.74C183.8 54.74 184.098 54.67 184.341 54.53C184.593 54.3807 184.794 54.1893 184.943 53.956C185.102 53.7133 185.214 53.4427 185.279 53.144C185.354 52.836 185.391 52.528 185.391 52.22C185.391 51.912 185.354 51.6133 185.279 51.324C185.204 51.0347 185.088 50.778 184.929 50.554C184.78 50.33 184.579 50.1527 184.327 50.022C184.084 49.8913 183.79 49.826 183.445 49.826C183.09 49.826 182.792 49.9007 182.549 50.05C182.306 50.1993 182.11 50.3953 181.961 50.638C181.812 50.8713 181.704 51.142 181.639 51.45C181.574 51.7487 181.541 52.0473 181.541 52.346C181.541 52.6447 181.578 52.9387 181.653 53.228C181.728 53.508 181.84 53.76 181.989 53.984C182.148 54.208 182.344 54.39 182.577 54.53C182.82 54.67 183.109 54.74 183.445 54.74ZM188.594 48.762H190.106V49.826L190.134 49.854C190.377 49.4527 190.694 49.14 191.086 48.916C191.478 48.6827 191.912 48.566 192.388 48.566C193.181 48.566 193.807 48.7713 194.264 49.182C194.721 49.5927 194.95 50.2087 194.95 51.03V56H193.354V51.45C193.335 50.8807 193.214 50.47 192.99 50.218C192.766 49.9567 192.416 49.826 191.94 49.826C191.669 49.826 191.427 49.8773 191.212 49.98C190.997 50.0733 190.815 50.2087 190.666 50.386C190.517 50.554 190.4 50.7547 190.316 50.988C190.232 51.2213 190.19 51.4687 190.19 51.73V56H188.594V48.762ZM200.641 46.004H202.391V51.828C202.391 52.164 202.405 52.5047 202.433 52.85C202.471 53.1953 202.564 53.508 202.713 53.788C202.872 54.0587 203.105 54.2827 203.413 54.46C203.731 54.6373 204.174 54.726 204.743 54.726C205.313 54.726 205.751 54.6373 206.059 54.46C206.377 54.2827 206.61 54.0587 206.759 53.788C206.918 53.508 207.011 53.1953 207.039 52.85C207.077 52.5047 207.095 52.164 207.095 51.828V46.004H208.845V52.402C208.845 53.046 208.747 53.606 208.551 54.082C208.355 54.558 208.075 54.9593 207.711 55.286C207.357 55.6033 206.927 55.8413 206.423 56C205.919 56.1587 205.359 56.238 204.743 56.238C204.127 56.238 203.567 56.1587 203.063 56C202.559 55.8413 202.125 55.6033 201.761 55.286C201.407 54.9593 201.131 54.558 200.935 54.082C200.739 53.606 200.641 53.046 200.641 52.402V46.004ZM210.675 48.762H212.187V49.742H212.215C212.439 49.322 212.752 49.0233 213.153 48.846C213.554 48.6593 213.988 48.566 214.455 48.566C215.024 48.566 215.519 48.6687 215.939 48.874C216.368 49.07 216.723 49.3453 217.003 49.7C217.283 50.0453 217.493 50.4513 217.633 50.918C217.773 51.3847 217.843 51.884 217.843 52.416C217.843 52.9013 217.778 53.3727 217.647 53.83C217.526 54.2873 217.334 54.6933 217.073 55.048C216.821 55.3933 216.499 55.6733 216.107 55.888C215.715 56.0933 215.253 56.196 214.721 56.196C214.488 56.196 214.254 56.1727 214.021 56.126C213.788 56.0887 213.564 56.0233 213.349 55.93C213.134 55.8367 212.934 55.72 212.747 55.58C212.57 55.4307 212.42 55.258 212.299 55.062H212.271V58.674H210.675V48.762ZM216.247 52.388C216.247 52.0613 216.205 51.744 216.121 51.436C216.037 51.128 215.911 50.8573 215.743 50.624C215.575 50.3813 215.365 50.19 215.113 50.05C214.861 49.9007 214.572 49.826 214.245 49.826C213.573 49.826 213.064 50.0593 212.719 50.526C212.383 50.9927 212.215 51.6133 212.215 52.388C212.215 52.752 212.257 53.0927 212.341 53.41C212.434 53.718 212.57 53.984 212.747 54.208C212.924 54.432 213.134 54.6093 213.377 54.74C213.629 54.8707 213.918 54.936 214.245 54.936C214.609 54.936 214.917 54.8613 215.169 54.712C215.421 54.5627 215.626 54.3713 215.785 54.138C215.953 53.8953 216.07 53.6247 216.135 53.326C216.21 53.018 216.247 52.7053 216.247 52.388Z"
                  fill="white" />
              </g>
              <defs>
                <filter
                  id="filter0_d_1975_117543"
                  x="0"
                  y="0"
                  width="386"
                  height="128"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha" />
                  <feOffset dy="13" />
                  <feGaussianBlur stdDeviation="20" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.658824 0 0 0 0 0.576471 0 0 0 0 0.976471 0 0 0 0.394586 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1975_117543" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1975_117543" result="shape" />
                </filter>
              </defs>
            </svg>
          </span>
        </div>

        <div
          id="faq-section"
          style="margin-top: 120px; margin-bottom: 10px; font-weight: 700; font-size: 42px; line-height: 50px; text-align: center; z-index: 1; width: 100%;">
          Frequently Asked Questions <span style="padding-left: 6px">✨</span>
        </div>

        <div style="width: 100%;">
          <FaqLayout>
            <div class="question-answer">
              <img src="/images/landing_page/tiktok/down.svg" class="arrow" />
              <h2>What is Benable?</h2>
              <div class="answer" style="margin-top: 15px; padding-left: 30px; line-height: 25px; font-size: 16px;">
                Benable is a tool to create beautiful, shareable lists of things you recommend. Ever get asked for
                recommendations? Benable is the all-in-one tool to share your favorite: products, places, services,
                activities, videos, recipes, and more!
                <div style="margin-top: 20px">
                  Save time, delight followers, and earn passive income. Prevent the things you’ve recommended from
                  getting buried in your feed or disappearing in your story! With Benable, you automatically compile
                  beautiful lists of things you recommend.
                </div>
              </div>
            </div>

            <div class="question-answer">
              <img src="/images/landing_page/tiktok/down.svg" class="arrow" />
              <h2>How does it work?</h2>
              <div class="answer" style="margin-top: 5px; line-height: 25px; font-size: 16px;">
                <p style="padding-left: 30px; padding-top: 15px">Using Benable is super simple:</p>
                <p style="padding-left: 30px; padding-top: 15px">
                  <b>Step 1:</b> Create a profile and start a new list (e.g. “Skincare Recs”, "Best Restaurants in LA", “Baby
                  Gear”, “Holiday Recipes” etc)
                </p>
                <p style="padding-left: 30px; padding-top: 15px">
                  <b>Step 2:</b> Add keywords or paste a link to something you recommend. Benable will automatically scan
                  the web to pull in all the info: photos, links, social, reviews, etc!
                </p>
                <p style="padding-left: 30px; padding-top: 15px">
                  <b>Step 3:</b> Confirm or edit the info as you like. E.g., upload your own photos, include an optional
                  note, etc.
                </p>
                <p style="padding-left: 30px; padding-top: 15px">
                  That’s it! Tap to get a shareable link to your Benable profile or lists, which you can add in your
                  Linktree, bio, or on your blog. Your friends and followers <u>don’t</u> need a Benable account to view
                  your Benable lists!
                </p>
              </div>
            </div>

            <div class="question-answer">
              <img src="/images/landing_page/tiktok/down.svg" class="arrow" />
              <h2>How do I earn passive income?</h2>
              <div class="answer" style="margin-top: 15px; padding-left: 30px; line-height: 25px; font-size: 16px;">
                Benable makes it easy to earn money from the things you recommend! Benable has partnered with over
                35,000+ sites that will pay you when someone makes a purchase from your list. When you join Benable you
                <u>instantly</u> get approved for all 35,000+ brand deals.

                <div style="padding-top: 20px">
                  Our brand partners include sites across products, apps, experiences, travel sites, subscriptions, and
                  more. Including <b
                    >Etsy, Lululemon, West Elm, Nike, Sephora, Tripadvisor, Wayfair, Minted, VRBO, Anthropologie,
                    Coursera, BestBuy, eBay, Ulta</b
                  >, etc. It even works with <b>Amazon!</b>
                </div>
                <div style="padding-top: 20px">
                  Anytime you add anything from these sites to your Benable list, Benable will auto-add a custom
                  affiliate link for you. And Benable doesn't take a cut, <b>you keep the whole commission</b>! (If you
                  already have a partnership with a brand, you’re welcome to use your own affiliate links.)
                </div>
              </div>
            </div>

            <div class="question-answer">
              <img src="/images/landing_page/tiktok/down.svg" class="arrow" />
              <h2>How does Benable work with things that don’t have affiliate links?</h2>
              <div class="answer" style="margin-top: 15px; padding-left: 30px; line-height: 25px; font-size: 16px;">
                Benable is a tool to compile all your recommendations into beautiful shareable lists. Many of the things
                people recommend don’t have affiliate links, e.g. restaurants, articles, parks, local services,
                activities, etc. You can still add those things to beautiful shareable lists on Benable even if they
                don’t result in a commission!
              </div>
            </div>

            <div class="question-answer">
              <img src="/images/landing_page/tiktok/down.svg" class="arrow" />
              <h2>How is Benable different from Amazon Storefronts and LTK?</h2>
              <div class="answer" style="margin-top: 15px; padding-left: 30px; line-height: 25px; font-size: 16px;">
                Amazon storefronts only let you add things from Amazon. On Benable you can recommend anything -
                including everything from Amazon. Also, tons of creators have told us Amazon is hard to use and clunky,
                whereas Benable is simple and effortless.

                <div style="margin-top: 20px">
                  LTK is great, but it’s mostly for fashion. While Benable works great for fashion (we have more fashion
                  brand partners than LTK!), you can also <u>add literally anything</u> you recommend. Travel recs, recipes,
                  books, videos, activities, articles, local services, etc. Also, Benable doesn’t take a penny of your commissions,
                  you keep the full amount.
                </div>
              </div>
            </div>

            <div class="question-answer">
              <img src="/images/landing_page/tiktok/down.svg" class="arrow" />
              <h2>How do I add my Benable to my Linktree, TikTok, or Instagram bio?</h2>
              <div class="answer" style="margin-top: 15px; padding-left: 30px; line-height: 25px; font-size: 16px;">
                Super easy, just copy your Benable profile link and paste it wherever you like! Most creators add their
                Benable profile link to their Linktree or in their bio.
              </div>
            </div>

            <div class="question-answer">
              <img src="/images/landing_page/tiktok/down.svg" class="arrow" />
              <h2>How much does Benable cost?</h2>
              <div class="answer" style="margin-top: 15px; padding-left: 30px; line-height: 25px; font-size: 16px;">
                Benable is free, and always will be! Eventually, Benable will monetize through paid ads in search
                results similar to Google, Pinterest, etc. (There will never be ads on your lists or profile).
              </div>
            </div>

            <div class="question-answer">
              <img src="/images/landing_page/tiktok/down.svg" class="arrow" />
              <h2>Who are you?</h2>
              <div class="answer" style="margin-top: 15px; padding-left: 30px; line-height: 25px; font-size: 16px;">
                Thanks for asking! We’re a team of folks, headquartered in the Washington, D.C. area with members
                sprinkled around the globe. We launched Benable about a year ago with the goal of making it easier for
                people to help one another by sharing recommendations. We are a registered Public Benefit Corporation,
                which means our mission is core to everything we do, and we are committed to driving a positive social
                impact.
              </div>
            </div>
          </FaqLayout>
        </div>

        <div
          style="background: #EBE4FF; opacity: 0.24; border-radius: 8px; height: 5px; width: 100%; max-width: 1135px; margin-left: auto; margin-right: auto;" />

        <div
          style="display: flex; align-items: center; margin-top: 34px; width: 100%; max-width: 1135px; margin-left: auto; margin-right: auto;">
          <a href="https://benable.com"><img src="/images/logo-black.svg" /></a>
          <a href="https://www.instagram.com/benable_hq/" target="_blank" style="margin-left: 16px; display: block;">
            <img src="/images/landing_page/tiktok/instagram.svg" />
          </a>
          <a href="https://www.tiktok.com/@benable_hq" target="_blank" style="margin-left: 16px; display: block;">
            <img src="/images/landing_page/tiktok/tiktok.svg" />
          </a>
          <div style="width: 100%" />
          <TermsAndPrivacyFooter location="tiktok-desktop" />
        </div>
      </div>
    </div>
  {:else}
    <div class="container-center-horizontal">
      <div class="x9-05-01-marketing-lp-mobile-v2 screen" style="height: unset;">
        <MobileHeader
          logoSrc={logoSrc}
          logoHref="/tiktok"
          options={[]}
          customOptionsSettings={[
            {
              label: () => 'Sign up',
              action: () => {
                displayCreateAccountModal();
              },
            },
            {
              label: () => 'FAQ',
              action: () => {
                location.href = '#faq-section';
              },
            },
            {
              label: () => 'Browse lists',
              action: () => {
                window.open(featuredListLink);
              },
            },
            {
              label: () => 'Login',
              action: () => {
                goto('/login');
              },
            },
          ]}>
          <div slot="additional-actions" style="padding-top: 3px;">
            <a href style="font-size: 15px;" on:click|preventDefault={displayCreateAccountModal}>
              <span style="margin-left: 7px" class="mobile-signup-link">Sign up</span>
            </a>
          </div>
        </MobileHeader>

        <img
          src="/images/landing_page/tiktok/mobile-background.png"
          style="position: absolute; top: 2320px; width: 100%; height: 1758px;" />

        <img src="/images/landing_page/tiktok/mobile-left.png" style="position: absolute; top: 3250px; left: 0px;" />
        <img src="/images/landing_page/tiktok/mobile-right.png" style="position: absolute; top: 3750px; right: 0px;" />

        <div class="hero-C61RwL" style="height: 1058px;">
          <div style="width: 100%; display: flex; justify-content: center;">
            <img
              alt="landing page"
              style="background: black; width: 100%; max-height: 570px; min-height: 550px; object-fit: fill;"
              class="overlay-6yINq5"
              src="/images/landing_page/tiktok/mobile-header.png"
              srcset="/images/landing_page/tiktok/mobile-header.png 1x, /images/landing_page/tiktok/mobile-header@2x.png 2x" />

            <img
              alt="landing page"
              style="width: 464px; height: 450px; top: 570px; margin-left: 70px;"
              class="overlay-6yINq5"
              src="/images/landing_page/tiktok/mobile-header-phone1.png"
              srcset="/images/landing_page/tiktok/mobile-header-phone1.png 1x, /images/landing_page/tiktok/mobile-header-phone1@2x.png 2x" />
          </div>

          <div class="input-6yINq5" style="margin-top: -40px;">
            <svg
              on:click={displayCreateAccountModal}
              style="position: absolute; left: -40px;"
              width="386"
              height="128"
              viewBox="0 0 386 128"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="signup-svg">
              <rect x="36" y="31.999" width="306" height="47" rx="16" fill="#2CEFEF" />
              <rect opacity="0.24" x="44" y="22.999" width="306" height="48" rx="16" fill="white" />
              <g filter="url(#filter0_d_1941_113883)">
                <rect x="40" y="26.999" width="306" height="48" rx="15" fill="#FE2B54" />
              </g>
              <defs>
                <filter
                  id="filter0_d_1941_113883"
                  x="0"
                  y="-0.000976562"
                  width="386"
                  height="128"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha" />
                  <feOffset dy="13" />
                  <feGaussianBlur stdDeviation="20" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.658824 0 0 0 0 0.576471 0 0 0 0 0.976471 0 0 0 0.394586 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1941_113883" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1941_113883" result="shape" />
                </filter>
              </defs>
            </svg>
            <div
              style="position: absolute; top: 41px; left: 128px; text-align: center; z-index: 1; pointer-events: none; color: white; font-weight: 500;">
              Sign up
            </div>
          </div>
          <div class="text-6yINq5">
            <div class="main-text-VpwlJ3">
              <div class="title-eIPOwk helveticaneue-bold-black-40px">Shareable lists</div>
              <div class="flex-row-eIPOwk">
                <div class="title-h0u3WP helveticaneue-bold-black-40px">of</div>
                <div class="overlap-group2-h0u3WP">
                  <div class="title-3Pr9RJ">
                    <div>{shareListWord}</div>
                    <img
                      alt="landing page"
                      loading="lazy"
                      class="line-3-3Pr9RJ"
                      src="/images/default-landing-page/line-3@2x.svg" />
                  </div>
                </div>
              </div>
              <div class="title-NuO8zd helveticaneue-bold-black-40px">you recommend</div>
            </div>
            <div class="benable-automat-recommendations-VpwlJ3 helveticaneue-regular-normal-butterfly-bush-16px">
              Earn passive income, save time, and delight followers! Recommend everything you love in one place.
            </div>
          </div>
        </div>
        <div class="magic-C61RwL" style="min-height: unset; margin-bottom: 30px;">
          <div class="title-jYPBvW helveticaneue-bold-black-30px" style="margin-top: -40px;">
            A platform for <span style="color: #AE94F9">creators</span> to compile and share their recommendations
          </div>
        </div>
        <div
          class="ticktokers-container"
          style="display: flex; flex-direction: row; overflow-x: scroll; overflow-y: hidden; width: 100%;"
          use:setScrollToTiktoker>
          {#each tiktokers as tiktoker}
            <a href={tiktoker.url} target="_blank" style="display: block;">
              <img
                src={tiktoker.view_urls.full_size}
                style="width: 196px; height: 260px; margin-left: 12px; margin-right: 12px;" />
            </a>
          {/each}
        </div>

        <div style="margin-top: 60px; z-index: 1;">
          <img
            src="/images/landing_page/tiktok/mobile-main.png"
            srcset="/images/landing_page/tiktok/mobile-main.png 1x, /images/landing_page/tiktok/mobile-main@2x.png 2x" />
        </div>

        <div class="example-images-mobile" style="width: 100%; margin-top: 40px;">
          <div style="font-weight: 700; font-size: 30px; line-height: 36px; text-align: center;">Browse more lists</div>
          <div
            style="margin-top: 16px; font-weight: 400; font-size: 16px; line-height: 24px; text-align: center; color: #5E518E;">
            Browse lists from top creators on Benable
          </div>

          <Photos photos={examplesArray} useFancyBox={false}>
            <div
              slot="img"
              let:photo
              style="margin-left: 10px; margin-right: 10px;"
              on:click|preventDefault|stopPropagation={() => window.open(photo.url)}>
              <img
                alt="landing page"
                on:click|preventDefault|stopPropagation={() => window.open(photo.url)}
                src={photo.view_urls['full_size']}
                srcset={photo.srcset}
                style="width: 314px; height: 480px; border-radius: 10px; box-shadow: 0px 22px 100px rgba(0, 0, 0, 0.12); margin-left: auto; margin-right: auto;" />
            </div>
          </Photos>
        </div>

        <div class="overlap-group-C61RwL" style="height: unset;  margin-top: 80px;">
          <div class="ready-4eduM0" style="position: unset;">
            <div class="rectangle-copy-55-sbFa6x" />
            <img alt="landing page" loading="lazy" class="vector-5-sbFa6x" src={ready.mobile.src} />
            <div class="benable-is-the-s-you-recommend-sbFa6x">
              Benable is the easiest way to make a beautiful list of things you recommend
            </div>
            <div
              style="position: absolute; bottom: 110px; left: 50%; transform: translate(-50%, 0%); width: 386px; margin-left: 40px;"
              on:click={displayCreateAccountModal}>
              <svg
                style="position: absolute; left: -40px;"
                width="386"
                height="128"
                viewBox="0 0 386 128"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="signup-svg">
                <rect x="36" y="31.999" width="306" height="47" rx="16" fill="#2CEFEF" />
                <rect opacity="0.24" x="44" y="22.999" width="306" height="48" rx="16" fill="white" />
                <g filter="url(#filter0_d_1941_113883)">
                  <rect x="40" y="26.999" width="306" height="48" rx="15" fill="#FE2B54" />
                </g>
                <defs>
                  <filter
                    id="filter0_d_1941_113883"
                    x="0"
                    y="-0.000976562"
                    width="386"
                    height="128"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha" />
                    <feOffset dy="13" />
                    <feGaussianBlur stdDeviation="20" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.658824 0 0 0 0 0.576471 0 0 0 0 0.976471 0 0 0 0.394586 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1941_113883" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1941_113883" result="shape" />
                  </filter>
                </defs>
              </svg>
              <div
                style="position: absolute; top: 41px; left: 128px; text-align: center; z-index: 1; pointer-events: none; color: white; font-weight: 500;">
                Sign up
              </div>
            </div>
            <div class="title-sbFa6x">Ready to start?</div>
          </div>
        </div>

        <div
          id="faq-section"
          style="font-weight: 700; font-size: 30px; line-height: 36px; margin-top: 60px; text-align: center;">
          Frequently Asked Questions <span style="padding-left: 6px">✨</span>
        </div>

        <div style="width: 100%; margin-top: -20px;" class="faq-section-layout">
          <FaqLayout>
            <div class="question-answer">
              <img src="/images/landing_page/tiktok/down.svg" class="arrow" />
              <h2 style="font-size: 16px; line-height: 24px; padding-right: 28px;">What is Benable?</h2>
              <div class="answer" style="margin-top: 15px; padding-left: 10px; line-height: 24px;">
                Benable is a tool to create beautiful, shareable lists of things you recommend. Ever get asked for
                recommendations? Benable is the all-in-one tool to share your favorite: products, places, services,
                activities, videos, recipes, and more!
                <div style="margin-top: 12px">
                  Save time, delight followers, and earn passive income. Prevent the things you’ve recommended from
                  getting buried in your feed or disappearing in your story! With Benable, you automatically compile
                  beautiful lists of things you recommend.
                </div>
              </div>
            </div>

            <div class="question-answer">
              <img src="/images/landing_page/tiktok/down.svg" class="arrow" />
              <h2 style="font-size: 16px; line-height: 24px; padding-right: 28px;">How does it work?</h2>
              <div class="answer" style="margin-top: 5px; line-height: 24px;">
                <p style="padding-left: 10px; padding-top: 12px">Using Benable is super simple:</p>
                <p style="padding-left: 10px; padding-top: 12px">
                  <b>Step 1:</b> Create a profile and start a new list (e.g. “Skincare Recs”, "Best Restaurants in LA", “Baby
                  Gear”, “Holiday Recipes” etc)
                </p>
                <p style="padding-left: 10px; padding-top: 12px">
                  <b>Step 2:</b> Add keywords or paste a link to something you recommend. Benable will automatically scan
                  the web to pull in all the info: photos, links, social, reviews, etc!
                </p>
                <p style="padding-left: 10px; padding-top: 12px">
                  <b>Step 3:</b> Confirm or edit the info as you like. E.g., upload your own photos, include an optional
                  note, etc.
                </p>
                <p style="padding-left: 10px; padding-top: 12px">
                  That’s it! Tap to get a shareable link to your Benable profile or lists, which you can add in your
                  Linktree, bio, or on your blog. Your friends and followers <u>don’t</u> need a Benable account to view
                  your Benable lists!
                </p>
              </div>
            </div>

            <div class="question-answer">
              <img src="/images/landing_page/tiktok/down.svg" class="arrow" />
              <h2 style="font-size: 16px; line-height: 24px; padding-right: 28px;">How do I earn passive income?</h2>
              <div class="answer" style="margin-top: 12px; padding-left: 10px; line-height: 24px;">
                Benable makes it easy to earn money from the things you recommend! Benable has partnered with over
                35,000+ sites that will pay you when someone makes a purchase from your list. When you join Benable you
                <u>instantly</u> get approved for all 35,000+ brand deals.

                <div style="padding-top: 20px">
                  Our brand partners include sites across products, apps, experiences, travel sites, subscriptions, and
                  more. Including <b
                    >Etsy, Lululemon, West Elm, Nike, Sephora, Tripadvisor, Wayfair, Minted, VRBO, Anthropologie,
                    Coursera, BestBuy, eBay, Ulta</b
                  >, etc. It even works with <b>Amazon!</b>
                </div>
                <div style="padding-top: 20px">
                  Anytime you add anything from these sites to your Benable list, Benable will auto-add a custom
                  affiliate link for you. And Benable doesn't take a cut, <b>you keep the whole commission</b>! (If you
                  already have a partnership with a brand, you’re welcome to use your own affiliate links.)
                </div>
              </div>
            </div>

            <div class="question-answer">
              <img src="/images/landing_page/tiktok/down.svg" class="arrow" />
              <h2 style="font-size: 16px; line-height: 24px; padding-right: 28px;">
                How does Benable work with things that don’t have affiliate links?
              </h2>
              <div class="answer" style="margin-top: 12px; padding-left: 10px; line-height: 24px;">
                Benable is a tool to compile all your recommendations into beautiful shareable lists. Many of the things
                people recommend don’t have affiliate links, e.g. restaurants, articles, parks, local services,
                activities, etc. You can still add those things to beautiful shareable lists on Benable even if they
                don’t result in a commission!
              </div>
            </div>

            <div class="question-answer">
              <img src="/images/landing_page/tiktok/down.svg" class="arrow" />
              <h2 style="font-size: 16px; line-height: 24px; padding-right: 28px;">
                How is Benable different from Amazon Storefronts and LTK?
              </h2>
              <div class="answer" style="margin-top: 12px; padding-left: 10px; line-height: 24px;">
                Amazon storefronts only let you add things from Amazon. On Benable you can recommend anything -
                including everything from Amazon. Also, tons of creators have told us Amazon is hard to use and clunky,
                whereas Benable is simple and effortless.

                <div style="margin-top: 20px">
                  LTK is great, but it’s mostly for fashion. While Benable works great for fashion (we have more fashion
                  brand partners than LTK!), you can also <u>add literally anything</u> you recommend. Travel recs, recipes,
                  books, videos, activities, articles, local services, etc. Also, Benable doesn’t take a penny of your commissions,
                  you keep the full amount.
                </div>
              </div>
            </div>

            <div class="question-answer">
              <img src="/images/landing_page/tiktok/down.svg" class="arrow" />
              <h2 style="font-size: 16px; line-height: 24px; padding-right: 28px;">
                How do I add my Benable to my Linktree, TikTok, or Instagram bio?
              </h2>
              <div class="answer" style="margin-top: 15px; padding-left: 10px; line-height: 24px;">
                Super easy, just copy your Benable profile link and paste it wherever you like! Most creators add their
                Benable profile link to their Linktree or in their bio.
              </div>
            </div>

            <div class="question-answer">
              <img src="/images/landing_page/tiktok/down.svg" class="arrow" />
              <h2 style="font-size: 16px; line-height: 24px; padding-right: 28px;">How much does Benable cost?</h2>
              <div class="answer" style="margin-top: 12px; padding-left: 10px; line-height: 24px;">
                Benable is free, and always will be! Eventually, Benable will monetize through paid ads in search
                results similar to Google, Pinterest, etc. (There will never be ads on your lists or profile).
              </div>
            </div>

            <div class="question-answer" style="border-bottom: 0px;">
              <img src="/images/landing_page/tiktok/down.svg" class="arrow" />
              <h2 style="font-size: 16px; line-height: 24px; padding-right: 28px;">Who are you?</h2>
              <div class="answer" style="margin-top: 12px; padding-left: 10px; line-height: 24px;">
                Thanks for asking! We’re a team of folks, headquartered in the Washington, D.C. area with members
                sprinkled around the globe. We launched Benable about a year ago with the goal of making it easier for
                people to help one another by sharing recommendations. We are a registered Public Benefit Corporation,
                which means our mission is core to everything we do, and we are committed to driving a positive social
                impact.
              </div>
            </div>
          </FaqLayout>
        </div>

        <div class="footer-4eduM0" style="position: unset;">
          <div class="input-tybepC" />
          <img alt="landing page" loading="lazy" class="logo-tybepC" src="/images/default-landing-page/logo@2x.svg" />
          <div class="flex-row-tybepC">
            <div style="margin-right: 20px;" on:click={() => window.open('https://tiktok.com/@benable_hq')}>
              <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 16.941V16.0758C0.243346 7.10569 8.0507 0.0553706 16.8382 0.501508C25.0038 0.920607 31.7837 7.7073 32 16.0758V16.9275C31.7837 25.1472 25.2336 31.8528 17.2573 32.4814H14.8171C6.88804 31.8596 0.223067 25.2148 0 16.941Z"
                  fill="black" />
                <path
                  d="M19.7649 14.0549C20.8873 14.8601 22.2624 15.3339 23.7475 15.3339V12.4659C23.4664 12.4659 23.1861 12.4365 22.9111 12.3781V14.6356C21.4261 14.6356 20.0512 14.1618 18.9285 13.3566V19.2094C18.9285 22.1372 16.5635 24.5105 13.6462 24.5105C12.5577 24.5105 11.546 24.1802 10.7056 23.6138C11.6648 24.5981 13.0025 25.2087 14.4824 25.2087C17.3998 25.2087 19.765 22.8354 19.765 19.9075L19.7649 14.0549ZM20.7966 11.1614C20.223 10.5325 19.8464 9.71975 19.7649 8.82121V8.45233H18.9723C19.1718 9.59438 19.8523 10.5701 20.7966 11.1614ZM12.5508 21.3671C12.2303 20.9454 12.0571 20.4295 12.0579 19.8991C12.0579 18.56 13.1396 17.4743 14.4742 17.4743C14.7229 17.4742 14.9701 17.5124 15.2072 17.5879V14.6558C14.9302 14.6177 14.6506 14.6016 14.3712 14.6075V16.8897C14.134 16.8142 13.8866 16.7759 13.6378 16.7761C12.3032 16.7761 11.2215 17.8617 11.2215 19.201C11.2215 20.1479 11.7622 20.9677 12.5508 21.3671Z"
                  fill="#FF004F" />
                <path
                  d="M18.9285 13.3566C20.0512 14.1618 21.4261 14.6356 22.9111 14.6356V12.3781C22.0822 12.2009 21.3484 11.7661 20.7966 11.1614C19.8523 10.5701 19.1718 9.59438 18.9723 8.45233H16.8902V19.9073C16.8855 21.2428 15.8056 22.3241 14.4739 22.3241C13.6891 22.3241 12.9923 21.9487 12.5508 21.3671C11.7622 20.9677 11.2215 20.1479 11.2215 19.201C11.2215 17.8617 12.3032 16.7761 13.6378 16.7761C13.8935 16.7761 14.14 16.816 14.3712 16.8897V14.6075C11.5052 14.6669 9.19993 17.0171 9.19993 19.9074C9.19993 21.3502 9.77402 22.6582 10.7056 23.6138C11.546 24.1802 12.5577 24.5105 13.6462 24.5105C16.5635 24.5105 18.9285 22.1372 18.9285 19.2094V13.3566Z"
                  fill="white" />
                <path
                  d="M22.9111 12.3781L22.9109 11.7676C22.1635 11.7688 21.4308 11.5587 20.7966 11.1614C21.358 11.7783 22.0973 12.2036 22.9111 12.3781ZM18.9723 8.45233C18.9533 8.34318 18.9385 8.23334 18.9284 8.12306V7.75417H16.0538V19.2093C16.0492 20.5445 14.9694 21.6259 13.6376 21.6259C13.2465 21.6259 12.8777 21.5326 12.5508 21.3671C12.9923 21.9487 13.6891 22.3241 14.4739 22.3241C15.8056 22.3241 16.8855 21.2428 16.8902 19.9073V8.45233H18.9723ZM14.3712 14.6075L14.371 13.9577C14.1308 13.9248 13.8887 13.9082 13.6462 13.9084C10.7287 13.9083 8.36364 16.2817 8.36364 19.2093C8.36364 21.0447 9.29317 22.6623 10.7056 23.6138C9.77402 22.6582 9.19993 21.3502 9.19993 19.9074C9.19993 17.0171 11.5052 14.6669 14.3712 14.6075Z"
                  fill="#00F2EA" />
              </svg>
            </div>
            <div on:click={() => window.open(instagramLink)} class="logo88x88-instagram-circle-lSYRvv" />
          </div>
          <div class="x-benable-2021-a-rights-reserved-tybepC" style="margin-top: 30px;">
            © Benable {new Date().getFullYear()}. All rights reserved.
          </div>
          <div style="margin-top: 20px">
            <TermsAndPrivacyFooter location="demo-template" mobile={true} />
          </div>
        </div>
      </div>
    </div>
  {/if}
</Viewport>
